import OrganisationDetails from './OrganisationDetailsContainer'

// Sync route definition
export default {
  path: '/organisations/:organisationId',
  component: OrganisationDetails,
}